import { StyledLink } from "@src/core/styles";
import type { FC } from "react";
import { NavContainer, NavGroup } from "./nav.styles";
import { Link } from "react-router-dom";
import { APP_ROUTES } from "@src/core/constants";
import { ReactComponent as Logo } from "@src/core/icons/logo.svg";
import {setNameValue} from "@src/core/store/authorize";
import {memo, useContext, useEffect} from "react";
import {Store} from "@src/core/store";
import {AuthTrueProps} from "@src/components/header/nav/nav.types";

export const Nav: FC<AuthTrueProps> = memo(({ isAuth }) =>{

    const handleButton = () => {
        return window.location.replace('/#price');
    }
    const handleToMain = () => {
        return window.location.replace('/');
    }

    return (
    <NavContainer>
      <StyledLink to="/" onClick={handleToMain}>
        <Logo />
      </StyledLink>
      <NavGroup>
          {isAuth && (
              <Link to={`${APP_ROUTES.DASHBOARD}`}>Панель управления</Link>
          )}
        <Link to={APP_ROUTES.TOOLS}>Инструменты</Link>
        <Link to="#" onClick={handleButton}>Тарифы</Link>
        {/*<Link to={`${APP_ROUTES.DOCUMENTATION}`}>Документация</Link>*/}
      </NavGroup>
    </NavContainer>
  );
});
